module.exports = __webpack_public_path__ + "img/vr-cardboard.8714a9eb.svg";